export default {
  patientImmunizations(state) {
    return (
      state.episode.immunizations.filter((item) => item.action !== "D") ?? []
    );
  },
};
